module.exports = __webpack_public_path__ + "img/volkswagen.e44e8f6e.png";